export default "__VITE_ASSET__0a172d6f__"